import CalendarImg from "./images/Calendar.png";
import AssessmentImg from "./images/Assessment_Icon.png";
// import LibraryImg from "./images/Library.png"
import HomeworkImg from "./images/Homework.jpg";
import PreReadImg from "./images/Pre_Read.png";
import ActivityImg from "./images/Activity.png";
import CommunityImg from "./images/Community_group.png";
import QueryImg from "./images/Query_group.png";
import HomeSideBar from "./images/teacher_menu_icon_home.svg";
// import ContentLibrarySideBar from "./images/teacher_menu_icon_content_library.svg"
import LecturemgtSideBar from "./images/teacher_menu_icon_lecture_mgt.svg";
// import QuestionLibrarySideBar from "./images/teacher_menu_icon_question_library.svg"
import HomeImage from "./images/teacher_menu_icon_home.png";
// import LectureMngImage from './images/teacher_menu_icon_lecture_mgt.png'
import ConentMngLibraryImage from "./images/teacher_menu_icon_content_library_black.png";
// import QuestionLibraryImage from './images/teacher_menu_icon_question_library.png'
// import ConentMngLibraryImagesideBar from './images/teacher_menu_icon_content_library_orange.png'
// import EngagementImageSVG from "./images/teacher_menu_icon_engagement.svg"
// import EngagementImagePNG from "./images/teacher_menu_icon_engagement copy.png"
// import AssessmentImageSVG from "./images/teacher_menu_icon_assessment.svg"
// import AssessmentImageSPNG from "./images/teacher_menu_icon_assessment copy.png"
// import HomeworkMGTSVG from "./images/teacher_menu_icon_homework_mgt.svg"
// import HomeworkMGTPNG from "./images/teacher_menu_icon_homework_mgt copy.png"
// import StudentAttendanceManag from "./images/attendIcon.png"
// import StudentAttendanceManagColored from "./images/attendIcon - Copy.png"
import QuestionLibraryIcon from "./images/question-library.svg";
import QuestionLibraryIconActive from "./images/question-library-active.svg";
import ContentLibraryIcon from "./images/content-library.svg";
import ContentLibraryIconActive from "./images/content-library-active.svg";
import LectureManagementIcon from "./images/lecture-management.svg";
import LectureManagementIconActive from "./images/lecture-management-active.svg";
import DashboardIcon from "./images/dashboard.svg";
import DashboardIconActive from "./images/dashboard-active.svg";
import AssessmentImageSVG from "./images/assessment.svg";
import AssessmentImageActive from "./images/assessment-active.svg";
import AssignmentIcon from "./images/assignment.svg";
import AssignmentIconActive from "./images/assignment-active.svg";
import EngagementIcon from "./images/engagement.svg";
import EngagementIconActive from "./images/engagement-active.svg";
import PerformanceIcon from "./images/performance.svg";
import PerformanceIconActive from "./images/performance-active.svg";
import AttendanceIcon from "./images/attendance.svg";
import AttendanceIconActive from "./images/attendance-active.svg";
import UploadIcon from "./images/upload.svg";
import OpenBook from "./images/book.svg";
import closeIcon from "./images/close.svg";
import LightBulbIcon from "./images/light-bulb.svg";
import LikeIcon from "./images/like.svg";
import commentIcon from "./images/comment.svg";
import BlueLikeIcon from "./images/LikeBlueIcon.svg";
import ReportCardIcon from './images/report-card.png'

const assets = {
  CalendarImg,
  AssessmentImg,
  HomeworkImg,
  PreReadImg,
  ActivityImg,
  CommunityImg,
  QueryImg,
  HomeSideBar,
  ContentLibraryIcon,
  ContentLibraryIconActive,
  LecturemgtSideBar,
  HomeImage,
  LectureManagementIcon,
  LectureManagementIconActive,
  ConentMngLibraryImage,
  QuestionLibraryIcon,
  AssignmentIcon,
  AssignmentIconActive,
  QuestionLibraryIconActive,
  EngagementIcon,
  EngagementIconActive,
  AssessmentImageSVG,
  AssessmentImageActive,
  DashboardIcon,
  DashboardIconActive,
  PerformanceIcon,
  PerformanceIconActive,
  AttendanceIcon,
  AttendanceIconActive,
  UploadIcon,
  OpenBook,
  closeIcon,
  LightBulbIcon,
  LikeIcon,
  BlueLikeIcon,
  commentIcon,
  ReportCardIcon
};
export default assets;
